"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Zendesk = Zendesk;
exports.ZendeskContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Launcher = _interopRequireDefault(require("../Launcher/Launcher.js"));
var _ZendeskScript = _interopRequireDefault(require("../ZendeskScript/ZendeskScript.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ZendeskContext = exports.ZendeskContext = /*#__PURE__*/(0, _react.createContext)({
  displayWidget: false,
  setDisplayWidget: () => {},
  widgetType: null,
  setWidgetType: () => {},
  unreadMessages: 0,
  setUnreadMessages: () => {}
});
// In case only messaging widget will be used in the future,, configure the ZendeskScript component to import dynamically
function Zendesk(_ref) {
  let {
    tenant,
    apiKey,
    onError
  } = _ref;
  const [displayWidget, setDisplayWidget] = (0, _react.useState)(false);
  const [widgetType, setWidgetType] = (0, _react.useState)(null);
  const [unreadMessages, setUnreadMessages] = (0, _react.useState)(0);

  //Widget Messenger: check when the widget closes
  (0, _react.useEffect)(() => {
    var _window;
    if (displayWidget && (_window = window) !== null && _window !== void 0 && _window.zE) {
      var _window2;
      (_window2 = window) === null || _window2 === void 0 || _window2.zE('messenger:on', 'close', () => {
        setDisplayWidget(false);
      });
    }
  }, [displayWidget]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ZendeskContext.Provider, {
    value: {
      displayWidget,
      setDisplayWidget,
      widgetType,
      setWidgetType,
      unreadMessages,
      setUnreadMessages
    }
  }, /*#__PURE__*/_react.default.createElement(_ZendeskScript.default, {
    tenant: tenant,
    apiKey: apiKey,
    onError: onError
  }), /*#__PURE__*/_react.default.createElement(_Launcher.default, null)));
}